import React from 'react';
import { MasterSearchInput } from '../atoms/MasterSearchInput';
import { DROPDOWN_STYLES } from '../constants/masterStyles';

interface SearchBarProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
}

export const MasterSearchBar: React.FC<SearchBarProps> = ({ value, onChange, placeholder }) => (
  <>
    <div style={DROPDOWN_STYLES.searchSection}>
      <MasterSearchInput value={value} onChange={onChange} placeholder={placeholder} />
    </div>
    <div style={DROPDOWN_STYLES.divider} />
  </>
);
